import { ProjectModel } from 'model/Project.model';

type GetPathWithReplacedProjectId = (projectId: ProjectModel['id']) => (location: string) => string;

export const getPathWithReplacedProjectId: GetPathWithReplacedProjectId = (projectId) => (
  location
) => {
  // Matches the first numeric path segment. The lookahead (?=/|$) matches
  // whether or not there is a trailing slash, so paths like "/42" (no sub-route)
  // are handled the same as "/42/home/summary".
  const projectIdRegex = new RegExp('/[0-9]+(?=/|$)');
  return location.replace(projectIdRegex, `/${projectId}`);
};
